export default {
  // 房屋查询页面
  'pages.search.house.tab.all': '全部房屋',
  'pages.search.house.tab.favorite': '我的收藏',

  // 房屋管理页面
  'pages.house.title': '房屋管理',
  'pages.house.subTitle': '管理小区内的房屋信息',
  'pages.house.breadcrumb.property': '物业管理',
  'pages.house.breadcrumb.baseData': '基础数据',
  'pages.house.breadcrumb.house': '房屋管理',

  // 房屋列表
  'pages.house.table.title': '房屋列表',
  'pages.house.table.columns.floor': '楼层',
  'pages.house.table.columns.building': '楼栋名称',
  'pages.house.table.columns.houseNumber': '房号',
  'pages.house.table.columns.houseType': '房屋类型',
  'pages.house.table.columns.area': '建筑面积(㎡)',
  'pages.house.table.columns.price': '金额(元)',
  'pages.house.table.columns.reserveAmount': '预定金额',
  'pages.house.table.columns.status': '房屋状态',
  'pages.house.table.columns.ownerName': '业主姓名',
  'pages.house.table.columns.ownerPhone': '业主电话',
  'pages.house.table.columns.createdTime': '创建时间',
  'pages.house.table.columns.operations': '操作',
  'pages.house.table.tab.all': '全部',
  'pages.house.table.tab.reserved': '已预订',

  // 房屋状态
  'pages.house.status.vacant': '空置',
  'pages.house.status.rented': '已出租',
  'pages.house.status.sold': '已出售',
  'pages.house.status.repairing': '维修中',
  'pages.house.detail.status.unknown': '状态{status}',

  // 操作按钮
  'pages.house.actions.view': '查看',
  'pages.house.actions.sell': '销售',

  // 房屋详情弹窗
  'pages.house.detail.title': '房屋详情',
  'pages.house.detail.loading': '加载中...',
  'pages.house.detail.tab.basic': '基本信息',
  'pages.house.detail.tab.sale': '房屋出售',
  'pages.house.detail.tab.rent': '房屋出租',
  'pages.house.detail.tab.bills': '费用查询',
  'pages.house.detail.tab.services': '水电网开通',
  'pages.house.detail.tab.repairComplaint': '保修与投诉',
  'pages.house.detail.tab.entryRegistration': '出入登记',
  'pages.house.detail.tab.repayment': '房屋还款',
  'pages.house.detail.tab.document': '关联文档',
  'pages.house.detail.tab.operationLog': '操作日志',
  'pages.house.detail.loading': '加载中...',
  
  // 房屋关联文档
  'pages.house.document.table.title': '关联文档',
  'pages.house.document.table.columns.category': '文档分类',
  'pages.house.document.table.columns.fileType': '文件类型',
  'pages.house.document.table.columns.fileSize': '文件大小',
  'pages.house.document.table.columns.createdBy': '创建人',
  'pages.house.document.table.columns.createdTime': '创建时间',
  'pages.house.document.table.columns.remarks': '备注',
  'pages.house.document.table.columns.action': '操作',
  'pages.house.document.action.add': '添加文档',
  'pages.house.document.action.download': '下载',
  'pages.house.document.action.chooseFile': '选择文件',
  'pages.house.document.action.uploading': '上传中',
  'pages.house.document.action.create': '添加',
  'pages.house.document.action.update': '更新',
  'pages.house.document.modal.createTitle': '添加文档',
  'pages.house.document.modal.editTitle': '编辑文档',
  'pages.house.document.form.category.label': '文档分类',
  'pages.house.document.form.category.placeholder': '请选择文档分类',
  'pages.house.document.form.category.required': '请选择文档分类',
  'pages.house.document.form.file.label': '文档文件',
  'pages.house.document.form.remarks.label': '备注',
  'pages.house.document.form.remarks.placeholder': '请输入备注信息',
  'pages.house.document.form.remarks.maxLength': '备注长度不能超过500个字符',
  'pages.house.document.tip.uploaded': '✓ 已上传: {name}',
  'pages.house.document.message.uploadSuccess': '文件上传成功',
  'pages.house.document.message.uploadFailed': '文件上传失败',
  'pages.house.document.message.createSuccess': '文档添加成功',
  'pages.house.document.message.createFailed': '添加失败',
  'pages.house.document.message.updateSuccess': '文档更新成功',
  'pages.house.document.message.updateFailed': '更新失败',
  'pages.house.document.message.deleteSuccess': '文档删除成功',
  'pages.house.document.message.deleteFailed': '删除失败',
  'pages.house.document.warning.noFilePath': '文件路径不存在',
  'pages.house.document.error.noBizId': '房屋ID不存在',
  'pages.house.document.validation.fileRequired': '请先上传文件',
  'pages.house.document.confirm.delete.title': '确认删除',
  'pages.house.document.confirm.delete.content': '确定要删除文档"{name}"吗？',
  'pages.house.detail.basicInfo': '基本信息',
  'pages.house.detail.ownerInfo': '业主信息',
  'pages.house.detail.saleInfo': '销售信息',
  'pages.house.detail.rentalInfo': '租赁信息',
  'pages.house.detail.priceInfo': '价格信息',
  'pages.house.detail.systemInfo': '系统信息',

  // 房屋操作日志
  'pages.house.operationLog.title': '操作日志',
  'pages.house.operationLog.action.refresh': '刷新',
  'pages.house.operationLog.columns.createdTime': '操作时间',
  'pages.house.operationLog.columns.logType': '操作类型',
  'pages.house.operationLog.columns.message': '操作信息',
  'pages.house.operationLog.columns.operatorName': '操作人',
  'pages.house.operationLog.columns.operatorIp': '操作IP',
  'pages.house.finance.table.title': '财务登记记录',
  'pages.house.finance.action.create': '新建登记',
  'pages.house.finance.column.applyTime': '申请时间',
  'pages.house.finance.column.feeType': '费用类型',
  'pages.house.finance.column.amount': '金额',
  'pages.house.finance.column.status': '状态',
  'pages.house.finance.column.applicant': '申请人',
  'pages.house.finance.column.remarks': '备注',
  'pages.house.finance.status.pending': '申请中',
  'pages.house.finance.status.approved': '已支付',
  'pages.house.finance.status.rejected': '已取消',
  'pages.house.finance.feeType.unknown': '未知',
  'pages.house.finance.modal.createTitle': '新建财务登记',
  'pages.house.finance.form.houseInfo': '房屋信息',
  'pages.house.finance.form.amountType': '金额类型',
  'pages.house.finance.form.amountType.placeholder': '请选择金额类型',
  'pages.house.finance.form.amountType.required': '请选择金额类型',
  'pages.house.finance.form.amountType.in': '收入',
  'pages.house.finance.form.amountType.out': '支出',
  'pages.house.finance.form.feeType': '费用类型',
  'pages.house.finance.form.feeType.dictLabel': '房产费用类型',
  'pages.house.finance.form.feeType.placeholder': '请选择费用类型',
  'pages.house.finance.form.feeType.required': '请选择费用类型',
  'pages.house.finance.form.amount': '金额',
  'pages.house.finance.form.amount.placeholder': '请输入金额',
  'pages.house.finance.form.amount.required': '请输入金额',
  'pages.house.finance.form.bankStatement': '银行账单',
  'pages.house.finance.form.bankStatement.placeholder': '请输入关键词搜索银行账单',
  'pages.house.finance.form.bankStatement.required': '请选择银行账单',
  'pages.house.finance.form.remarks': '备注',
  'pages.house.finance.form.remarks.placeholder': '请输入备注信息',
  'pages.house.finance.message.houseIdMissing': '房屋ID不存在',
  'pages.house.finance.message.createSuccess': '财务登记成功',
  'pages.house.finance.message.createFailed': '财务登记失败',
  'pages.house.finance.message.createRetry': '财务登记失败，请稍后重试',
  'pages.house.finance.error.loadFeeTypeFailed': '加载费用类型字典失败',
  'pages.house.finance.error.searchBankStatementFailed': '搜索银行账单失败',

  // 房屋出售（详情 - Sale Tab）
  'pages.house.sale.section.saleAmount': '销售金额',
  'pages.house.sale.section.propertyBasePrice': '物业与基础售价',
  'pages.house.sale.section.taxCommission': '税费与渠道佣金分配',
  'pages.house.sale.section.channelReward': '渠道奖励与结算信息',
  'pages.house.sale.section.saleInfo': '销售信息',
  'pages.house.sale.section.loanInfo': '贷款信息',
  'pages.house.sale.section.reserveInfo': '预订信息',
  'pages.house.sale.section.agentInfo': '中介信息',
  'pages.house.sale.button.viewRepaymentPlan': '查看还款计划',
  'pages.house.sale.repaymentPlan.title': '房贷还款计划',
  'pages.house.sale.soldType.loan': '贷款',
  'pages.house.sale.soldType.fullPayment': '全款',
  'pages.house.sale.label.salePrice': '销售价格(单价*面积)',
  'pages.house.sale.label.unitPrice': '单价',
  'pages.house.sale.label.unitPriceWithUnit': '单价',
  'pages.house.sale.label.buildArea': '建筑面积 (㎡)',
  'pages.house.sale.label.commissionRate': '佣金费率',
  'pages.house.sale.label.editFeeAmount': '编辑金额',
  'pages.house.sale.button.confirm': '确定',
  'pages.house.sale.label.linkedCalculation': '联动计算',
  'pages.house.sale.label.agentBonusWithUnit': '公司赠奖励',
  'pages.house.sale.label.personalBonusWithUnit': '个人赠特奖',
  'pages.house.sale.financialReport.title': '财务报告盘',
  'pages.house.sale.financialReport.realtime': '实时联动',
  'pages.house.sale.financialReport.contractTotalPayable': '合同总价格 (应付)',
  'pages.house.sale.financialReport.yuan': '元',
  'pages.house.sale.cashFlow.title': '资金流占比结构',
  'pages.house.sale.cashFlow.proportionStructure': '占比结构',
  'pages.house.sale.cashFlow.salePrice': '售价',
  'pages.house.sale.cashFlow.dualReward': '双端奖励',
  'pages.house.sale.label.vat': '增值税 (12%)',
  'pages.house.sale.label.transferFee': '转让费 (9%)',
  'pages.house.sale.label.agentBonus': '公司奖励',
  'pages.house.sale.label.personalBonus': '个人奖励',
  'pages.house.sale.label.commission': '佣金(5%)',
  'pages.house.sale.label.feeWithRate': '{name}({rate})',
  'pages.house.sale.config.houseSalesConfig': '房屋销售税配置',
  'pages.house.sale.config.loadFailed': '加载房屋销售税配置失败',
  'pages.house.sale.config.updateSuccess': '房屋销售税配置已更新',
  'pages.house.sale.config.updateFailed': '更新房屋销售税配置失败',
  'pages.house.sale.config.percentRequired': '请输入百分比',
  'pages.house.sale.label.contractTotalPrice': '合同总价格',
  'pages.house.sale.label.discountAmount': '折扣金额',
  'pages.house.sale.label.companyFinalProfit': '公司最终盈利',
  'pages.house.sale.label.soldType': '销售类型',
  'pages.house.sale.label.soldTime': '销售时间',
  'pages.house.sale.label.mortgageStartTime': '房贷还款开始时间',
  'pages.house.sale.label.mortgageEndTime': '房贷还款结束时间',
  'pages.house.sale.label.monthlyRepaymentLimit': '每月还款额度',
  'pages.house.sale.label.reserveUserName': '预定人姓名',
  'pages.house.sale.label.reserveUserPhone': '预定人手机号',
  'pages.house.sale.label.reserveAmount': '预定金额',
  'pages.house.sale.label.reserveTime': '预定时间',
  'pages.house.sale.label.agentName': '中介姓名',
  'pages.house.sale.label.agentPhone': '中介电话',
  'pages.house.sale.label.agentCommission': '中介费',
  'pages.house.sale.label.mortgageTimeRange': '房贷还款时间',
  'pages.house.sale.label.relatedProject': '关联项目',
  'pages.house.sale.label.repaymentDay': '还款日',
  'pages.house.sale.placeholder.salePrice': '请输入销售价格',
  'pages.house.sale.placeholder.unitPrice': '请输入单价',
  'pages.house.sale.placeholder.vat': '请输入增值税',
  'pages.house.sale.placeholder.transferFee': '请输入转让费',
  'pages.house.sale.placeholder.agentBonus': '请输入公司奖励',
  'pages.house.sale.placeholder.personalBonus': '请输入个人奖励',
  'pages.house.sale.placeholder.commission': '请输入佣金(5%)',
  'pages.house.sale.placeholder.feeAmount': '请输入金额',
  'pages.house.sale.placeholder.contractTotalPrice': '请输入合同总价格',
  'pages.house.sale.placeholder.discountAmount': '请输入折扣金额',
  'pages.house.sale.placeholder.companyFinalProfit': '请输入公司最终盈利',
  'pages.house.sale.placeholder.autoCalculated': '自动计算',
  'pages.house.sale.placeholder.soldType': '请选择销售类型',
  'pages.house.sale.placeholder.mortgageStartMonth': '开始月份',
  'pages.house.sale.placeholder.mortgageEndMonth': '结束月份',
  'pages.house.sale.placeholder.relatedProject': '请选择关联项目',
  'pages.house.sale.placeholder.repaymentDay': '请选择还款日',
  'pages.house.sale.validation.salePriceMin': '销售价格不能为负数',
  'pages.house.sale.validation.vatMin': '增值税不能为负数',
  'pages.house.sale.validation.transferFeeMin': '转让费不能为负数',
  'pages.house.sale.validation.unitPriceMin': '单价不能为负数',
  'pages.house.sale.validation.agentBonusMin': '公司奖励不能为负数',
  'pages.house.sale.hint.area': '面积：{area}㎡',
  'pages.house.sale.validation.personalBonusMin': '个人奖励不能为负数',
  'pages.house.sale.validation.commissionMin': '佣金(5%)不能为负数',
  'pages.house.sale.validation.contractTotalPriceMin': '合同总价格不能为负数',
  'pages.house.sale.validation.discountAmountMin': '折扣金额不能为负数',
  'pages.house.sale.validation.companyFinalProfitMin': '公司最终盈利不能为负数',
  'pages.house.sale.validation.soldTypeRequired': '请选择销售类型',
  'pages.house.sale.validation.relatedProjectRequired': '请选择关联项目',
  'pages.house.sale.validation.repaymentDayRequired': '请选择还款日',
  'pages.house.sale.tooltip.contractTotalPrice':
    '合同总价格 = 销售价格 + 增值税 + 转让费',
  'pages.house.sale.tooltip.companyFinalProfit':
    '公司最终盈利 = 销售价格 - 中介费 - 公司奖励 - 个人奖励',

  // 详情字段标签
  'pages.house.detail.label.building': '楼栋',
  'pages.house.detail.label.floor': '楼层',
  'pages.house.detail.label.houseNumber': '房号',
  'pages.house.detail.label.houseType': '房屋类型',
  'pages.house.detail.label.area': '建筑面积',
  'pages.house.detail.label.status': '房屋状态',
  'pages.house.detail.label.ownerName': '业主姓名',
  'pages.house.detail.label.ownerPhone': '业主电话',
  'pages.house.detail.bindAppInfo': '绑定APP账户',
  'pages.house.detail.label.appUsername': 'APP用户名',
  'pages.house.detail.label.appName': 'APP姓名',
  'pages.house.detail.label.appPhone': 'APP电话',
  'pages.house.detail.label.appEmail': 'APP邮箱',
  'pages.house.detail.label.saleAmount': '销售金额',
  'pages.house.detail.label.discountAmount': '优惠金额',
  'pages.house.detail.label.finalAmount': '最终金额',
  'pages.house.detail.label.monthlyRepaymentLimit': '每月还款金额',
  'pages.house.detail.label.saleTime': '销售时间',
  'pages.house.detail.label.rent': '租金',
  'pages.house.detail.label.rentPeriod': '租期',
  'pages.house.detail.label.houseAmount': '房屋金额',
  'pages.house.detail.label.createdTime': '创建时间',
  'pages.house.detail.label.updatedTime': '更新时间',
  'pages.house.detail.label.remarks': '备注',

  // 还款计划（通用展示）
  'pages.house.repaymentPlan.title': '还款计划',
  'pages.house.repaymentPlan.stat.total': '还款总计',
  'pages.house.repaymentPlan.stat.monthlyAvg': '月度平均',
  'pages.house.repaymentPlan.stat.months': '还款月数',
  'pages.house.repaymentPlan.unit.months': '个月',
  'pages.house.repaymentPlan.empty': '暂无还款计划数据',
  'pages.house.repaymentPlan.loadFailed': '加载还款计划失败',
  'pages.house.repaymentPlan.label.year': '{year}年',
  'pages.house.repaymentPlan.yearTotal': '年度总计',
  'pages.house.repaymentPlan.monthRepayment': '{month}月还款',

  // 还款配置（年度计划）
  'pages.house.repaymentConfig.button.open': '配置还款计划',
  'pages.house.repaymentConfig.modal.title': '还款配置年度计划',
  'pages.house.repaymentConfig.quickGenerate.title': '快速生成计划',
  'pages.house.repaymentConfig.quickGenerate.button': '生成计划',
  'pages.house.repaymentConfig.quickGenerate.start': '开始时间',
  'pages.house.repaymentConfig.quickGenerate.end': '结束时间',
  'pages.house.repaymentConfig.quickGenerate.limit': '每月还款额度 (¥)',
  'pages.house.repaymentConfig.tip.needMortgageConfig': '请先配置房贷还款时间和每月还款额度',
  'pages.house.repaymentConfig.warning.needMortgageConfig': '请先配置房贷还款时间和每月还款额度',
  'pages.house.repaymentConfig.message.generated': '已生成还款计划',
  'pages.house.repaymentConfig.message.setAllMonths': '已将 {year} 年所有月份设置为 ¥{amount}',
  'pages.house.repaymentConfig.message.clearedYear': '已清空 {year} 年所有月份',
  'pages.house.repaymentConfig.button.setAllMonths': '统一设置',
  'pages.house.repaymentConfig.button.clearYear': '全部清空',
  'pages.house.repaymentConfig.inputAmountPlaceholder': '输入金额',
  'pages.house.repaymentConfig.empty': '暂无还款数据，请点击"生成计划"按钮',

  // 按钮
  'pages.house.detail.button.close': '关闭',

  // 费用查询（房屋详情-账单列表）
  'pages.house.billList.filter.billType': '费用类型',
  'pages.house.billList.filter.paymentStatus': '缴费状态',
  'pages.house.billList.filter.paymentStatus.placeholder': '全部状态',
  'pages.house.billList.filter.paymentStatus.all': '全部状态',

  'pages.house.billList.billType.property': '物业费',
  'pages.house.billList.billType.water': '水费',
  'pages.house.billList.billType.electric': '电费',
  'pages.house.billList.billType.network': '网费',
  'pages.house.billList.billType.parking': '停车费',
  'pages.house.billList.billType.other': '其他费用',

  'pages.house.billList.action.search': '查询',
  'pages.house.billList.action.detail': '详情',
  'pages.house.billList.action.close': '关闭',

  'pages.house.billList.table.columns.period': '账期',
  'pages.house.billList.table.columns.billNo': '账单编号',
  'pages.house.billList.table.columns.finalAmount': '应缴金额',
  'pages.house.billList.table.columns.approvalStatus': '审核状态',
  'pages.house.billList.table.columns.paymentStatus': '缴费状态',
  'pages.house.billList.table.columns.paidDate': '缴费时间',
  'pages.house.billList.table.columns.dueDate': '到期时间',
  'pages.house.billList.table.columns.createdTime': '创建时间',
  'pages.house.billList.table.columns.action': '操作',

  'pages.house.billList.empty.noHouse': '暂无房屋信息',
  'pages.house.billList.pagination.total': '第 {from}-{to} 条/总共 {total} 条',

  'pages.house.billList.modal.title.property': '物业费账单详情',
  'pages.house.billList.modal.title.water': '水费账单详情',
  'pages.house.billList.modal.title.electric': '电费账单详情',
  'pages.house.billList.modal.title.network': '网费账单详情',
  'pages.house.billList.modal.title.parking': '停车费账单详情',
  'pages.house.billList.modal.title.other': '其他费用账单详情',
  'pages.house.billList.modal.title.default': '账单详情',

  'pages.house.billList.error.loadBillStatusDictFailed': '加载缴费状态字典失败',
  'pages.house.billList.error.loadApproveStatusDictFailed': '加载审核状态字典失败',
  'pages.house.billList.error.loadBillListFailed': '获取账单列表失败',

  // 房屋详情-服务开通（水电网）
  'pages.house.services.table.title': '水电网服务开通',
  'pages.house.services.table.columns.index': '序号',
  'pages.house.services.table.columns.serviceName': '服务名称',
  'pages.house.services.table.columns.unitPrice': '单价',
  'pages.house.services.table.columns.serviceStatus': '服务状态',
  'pages.house.services.table.columns.startDate': '开始日期',
  'pages.house.services.table.columns.endDate': '结束日期',
  'pages.house.services.table.columns.remarks': '备注',
  'pages.house.services.table.columns.operations': '操作',
  'pages.house.services.status.enabled': '启用',
  'pages.house.services.status.disabled': '停用',
  'pages.house.services.action.enable': '启用',
  'pages.house.services.action.disable': '停用',
  'pages.house.services.action.openService': '开通服务',
  'pages.house.services.confirm.enableService': '确认启用该服务？',
  'pages.house.services.confirm.disableService': '确认停用该服务？',
  'pages.house.services.message.serviceEnableSuccess': '服务已启用',
  'pages.house.services.message.serviceDisableSuccess': '服务已停用',
  'pages.house.services.message.operationFailed': '操作失败',
  'pages.house.services.message.getDataFailed': '获取数据失败',
  'pages.house.services.empty.noHouse': '暂无房屋信息',
  'pages.house.services.table.pagination.total':
    '第 {start}-{end} 条/总共 {total} 条',

  // 收藏
  'pages.house.favorite.button.favorite': '收藏',
  'pages.house.favorite.button.favorited': '已收藏',
  'pages.house.favorite.message.favoriteSuccess': '收藏成功',
  'pages.house.favorite.message.favoriteFailed': '收藏失败',
  'pages.house.favorite.message.unfavoriteSuccess': '已取消收藏',
  'pages.house.favorite.message.unfavoriteFailed': '取消收藏失败',
  'pages.house.favorite.message.actionFailed': '操作失败',

  // 房屋详情 - 保修与投诉
  'pages.house.repairComplaint.filter.category': '分类类型',
  'pages.house.repairComplaint.filter.status': '处理状态',
  'pages.house.repairComplaint.category.maintenance': '保修',
  'pages.house.repairComplaint.category.complaint': '投诉',
  'pages.house.repairComplaint.target.workOrder': '工单',
  'pages.house.repairComplaint.target.complaint': '投诉',

  'pages.house.repairComplaint.status.pending': '待处理',
  'pages.house.repairComplaint.status.inProgress': '处理中',
  'pages.house.repairComplaint.status.completed': '处理完成',
  'pages.house.repairComplaint.status.resolved': '已解决',

  'pages.house.repairComplaint.table.workOrderNo': '工单编号',
  'pages.house.repairComplaint.table.complaintNo': '投诉编号',
  'pages.house.repairComplaint.table.repairType': '维修类型',
  'pages.house.repairComplaint.table.complaintType': '投诉类型',
  'pages.house.repairComplaint.table.title': '标题',
  'pages.house.repairComplaint.table.urgeCount': '催单次数',
  'pages.house.repairComplaint.table.createdTime': '创建时间',
  'pages.house.repairComplaint.table.status': '状态',
  'pages.house.repairComplaint.table.action': '操作',

  'pages.house.repairComplaint.action.startProcess': '开始处理',
  'pages.house.repairComplaint.action.addProgress': '添加进度',
  'pages.house.repairComplaint.action.complete': '处理完成',
  'pages.house.repairComplaint.action.view': '查看',

  'pages.house.repairComplaint.drawer.detail.title.maintenance': '维修工单详情',
  'pages.house.repairComplaint.drawer.detail.title.complaint': '投诉详情',
  'pages.house.repairComplaint.drawer.start.title': '开始处理{type}',
  'pages.house.repairComplaint.drawer.start.confirm': '确认开始处理',
  'pages.house.repairComplaint.drawer.complete.title': '处理完成',
  'pages.house.repairComplaint.drawer.complete.confirm': '确认完成',
  'pages.house.repairComplaint.drawer.addProgress.title': '添加处理进度',

  'pages.house.repairComplaint.section.basicInfo': '基本信息',
  'pages.house.repairComplaint.section.ownerInfo': '业主信息',
  'pages.house.repairComplaint.section.complainantInfo': '投诉人信息',
  'pages.house.repairComplaint.section.maintenanceDesc': '维修描述',
  'pages.house.repairComplaint.section.complaintDesc': '投诉描述',
  'pages.house.repairComplaint.section.maintenanceImages': '报修图片',
  'pages.house.repairComplaint.section.complaintImages': '投诉图片',
  'pages.house.repairComplaint.section.systemInfo': '系统信息',
  'pages.house.repairComplaint.section.progress': '处理进度',
  'pages.house.repairComplaint.section.handleRemark': '处理备注',
  'pages.house.repairComplaint.section.completeRemark': '完成备注',
  'pages.house.repairComplaint.section.addNewProgress': '添加新进度',

  'pages.house.repairComplaint.field.workOrderNo': '工单编号',
  'pages.house.repairComplaint.field.complaintNo': '投诉编号',
  'pages.house.repairComplaint.field.repairType': '维修类型',
  'pages.house.repairComplaint.field.complaintType': '投诉类型',
  'pages.house.repairComplaint.field.status': '状态',
  'pages.house.repairComplaint.field.urgeCount': '催单次数',
  'pages.house.repairComplaint.field.ownerName': '业主姓名',
  'pages.house.repairComplaint.field.ownerPhone': '业主电话',
  'pages.house.repairComplaint.field.ownerEmail': '业主邮箱',
  'pages.house.repairComplaint.field.complainantName': '投诉人姓名',
  'pages.house.repairComplaint.field.complainantPhone': '投诉人电话',
  'pages.house.repairComplaint.field.complainantEmail': '投诉人邮箱',
  'pages.house.repairComplaint.field.title': '标题',
  'pages.house.repairComplaint.field.description': '描述内容',
  'pages.house.repairComplaint.field.createdTime': '创建时间',
  'pages.house.repairComplaint.field.updatedTime': '更新时间',
  'pages.house.repairComplaint.field.remarks': '备注',

  'pages.house.repairComplaint.form.remark.label': '备注信息',
  'pages.house.repairComplaint.form.remark.required': '请输入处理备注',
  'pages.house.repairComplaint.form.complete.required': '请输入完成备注',
  'pages.house.repairComplaint.form.remark.min': '备注信息至少{min}个字符',
  'pages.house.repairComplaint.form.remark.placeholder.start': '请输入开始处理的备注信息，说明处理计划、预计时间等',
  'pages.house.repairComplaint.form.remark.placeholder.complete': '请输入处理完成的备注信息，说明完成情况、处理结果等',

  'pages.house.repairComplaint.form.progress.required': '请输入进度说明',
  'pages.house.repairComplaint.form.progress.min': '进度说明至少{min}个字符',
  'pages.house.repairComplaint.form.progress.placeholder': '请输入本次处理的进度说明',

  'pages.house.repairComplaint.unit.times': '{count} 次',
  'pages.house.repairComplaint.image.alt': '{type}图片{index}',

  'pages.house.repairComplaint.loading': '加载中...',
  'pages.house.repairComplaint.empty.noProgress': '暂无进度记录',
  'pages.house.repairComplaint.empty.noUrge': '暂无催单',

  'pages.house.repairComplaint.message.workOrderToInProgress': '工单已转为处理中',
  'pages.house.repairComplaint.message.complaintToInProgress': '投诉已转为处理中',
  'pages.house.repairComplaint.message.workOrderCompleted': '工单已完成',
  'pages.house.repairComplaint.message.complaintResolved': '投诉已解决',
  'pages.house.repairComplaint.message.progressAddSuccess': '进度添加成功',

  'pages.house.repairComplaint.error.recordIdMissing': '记录ID不存在',
  'pages.house.repairComplaint.error.statusChangeFailed': '状态变更失败',
  'pages.house.repairComplaint.error.completeFailed': '完成失败',
  'pages.house.repairComplaint.error.progressAddFailed': '添加进度失败',

  // 房屋选择
  'pages.house.select.current': '当前选择：',
  'pages.house.select.building': '楼栋',
  'pages.house.select.floor': '楼层',

// 货币符号
'pages.house.currency.symbol': '₱',

// 车辆表单弹窗
'pages.house.vehicle.form.editTitle': '编辑车辆',
'pages.house.vehicle.form.bindTitle': '绑定车辆',
'pages.house.vehicle.form.parkingInfo': '车位信息',
'pages.house.vehicle.form.basicInfo': '基本信息',
'pages.house.vehicle.form.remarksInfo': '备注信息',
'pages.house.vehicle.form.parking': '车位',
'pages.house.vehicle.form.plateNumber': '车牌号',
'pages.house.vehicle.form.vehicleType': '车辆类型',
'pages.house.vehicle.form.brand': '品牌',
'pages.house.vehicle.form.model': '车型',
'pages.house.vehicle.form.color': '车辆颜色',
'pages.house.vehicle.form.registrationDate': '注册日期',
'pages.house.vehicle.form.remarks': '备注',
'pages.house.vehicle.form.plateNumberRequired': '请输入车牌号',
'pages.house.vehicle.form.plateNumberMaxLength': '车牌号长度不能超过20个字符',
'pages.house.vehicle.form.vehicleTypeRequired': '请选择车辆类型',
'pages.house.vehicle.form.brandMaxLength': '品牌长度不能超过50个字符',
'pages.house.vehicle.form.modelMaxLength': '车型长度不能超过50个字符',
'pages.house.vehicle.form.colorMaxLength': '颜色长度不能超过20个字符',
'pages.house.vehicle.form.remarksMaxLength': '备注长度不能超过500个字符',
'pages.house.vehicle.form.plateNumberPlaceholder': '请输入车牌号',
'pages.house.vehicle.form.vehicleTypePlaceholder': '请选择车辆类型',
'pages.house.vehicle.form.brandPlaceholder': '请输入品牌，如：奔驰、丰田',
'pages.house.vehicle.form.modelPlaceholder': '请输入车型，如：C级、卡罗拉',
'pages.house.vehicle.form.colorPlaceholder': '请输入车辆颜色',
'pages.house.vehicle.form.registrationDatePlaceholder': '请选择注册日期',
'pages.house.vehicle.form.remarksPlaceholder': '请输入备注信息',
'pages.house.vehicle.form.updateSuccess': '更新成功',
'pages.house.vehicle.form.createSuccess': '创建成功',
'pages.house.vehicle.form.updateFailed': '更新失败',
'pages.house.vehicle.form.createFailed': '创建失败',

// 房屋表单弹窗
'pages.house.form.editTitle': '房屋销售',
'pages.house.form.createTitle': '新建房屋',
'pages.house.form.basicInfo': '基本信息',
'pages.house.form.ownerInfo': '业主信息',
'pages.house.form.saleInfo': '销售信息',
'pages.house.form.rentalInfo': '租赁信息',
'pages.house.form.remarksInfo': '备注信息',
'pages.house.form.building': '所属楼栋',
'pages.house.form.floor': '楼层',
'pages.house.form.houseNumber': '房号',
'pages.house.form.area': '建筑面积(㎡)',
'pages.house.form.houseType': '房屋类型',
'pages.house.form.status': '房屋状态',
'pages.house.form.ownerName': '业主姓名',
'pages.house.form.ownerPhone': '业主电话',
'pages.house.form.saleAmount': '销售金额',
'pages.house.form.discountAmount': '优惠金额',
'pages.house.form.finalAmount': '最终金额',
'pages.house.form.monthlyRepaymentLimit': '每月还款额度',
'pages.house.form.saleTime': '销售时间',
'pages.house.form.rent': '租金',
'pages.house.form.rentStartTime': '开始时间',
'pages.house.form.rentEndTime': '结束时间',
'pages.house.form.remarks': '备注',
'pages.house.form.ownerSearch': '查询',
'pages.house.form.ownerClear': '清除',
'pages.house.form.buildingRequired': '请选择楼栋',
'pages.house.form.floorRequired': '请选择楼层',
'pages.house.form.houseNumberRequired': '请输入房号',
'pages.house.form.houseNumberMaxLength': '房号长度不能超过20个字符',
'pages.house.form.areaRequired': '请输入建筑面积',
'pages.house.form.areaMaxLength': '建筑面积长度不能超过50个字符',
'pages.house.form.houseTypeRequired': '请选择房屋类型',
'pages.house.form.statusRequired': '请选择房屋状态',
'pages.house.form.saleAmountRequired': '请输入销售金额',
'pages.house.form.saleAmountMin': '销售金额不能为负数',
'pages.house.form.discountAmountMin': '优惠金额不能为负数',
'pages.house.form.finalAmountRequired': '请输入最终金额',
'pages.house.form.finalAmountMin': '最终金额不能为负数',
'pages.house.form.monthlyRepaymentLimitMin': '每月还款额度不能为负数',
'pages.house.form.saleTimeRequired': '请选择销售时间',
'pages.house.form.rentRequired': '请输入租金',
'pages.house.form.rentMin': '租金不能为负数',
'pages.house.form.rentStartTimeRequired': '请选择开始时间',
'pages.house.form.rentEndTimeRequired': '请选择结束时间',
'pages.house.form.remarksMaxLength': '备注长度不能超过500个字符',
'pages.house.form.buildingPlaceholder': '请选择楼栋',
'pages.house.form.floorPlaceholder': '请选择楼层',
'pages.house.form.houseNumberPlaceholder': '请输入房号',
'pages.house.form.areaPlaceholder': '请输入建筑面积',
'pages.house.form.houseTypePlaceholder': '请选择房屋类型',
'pages.house.form.statusPlaceholder': '请选择房屋状态',
'pages.house.form.ownerNamePlaceholder': '请输入业主姓名',
'pages.house.form.ownerPhonePlaceholder': '请输入业主电话',
'pages.house.form.bindApp': '绑定APP账户',
'pages.house.form.bindAppPlaceholder': '请通过查询选择绑定APP用户',
'pages.house.form.saleAmountPlaceholder': '请输入销售金额',
'pages.house.form.discountAmountPlaceholder': '请输入优惠金额',
'pages.house.form.finalAmountPlaceholder': '自动计算',
'pages.house.form.monthlyRepaymentLimitPlaceholder': '请输入每月还款额度',
'pages.house.form.saleTimePlaceholder': '请选择销售时间',
'pages.house.form.rentPlaceholder': '请输入租金',
'pages.house.form.rentStartTimePlaceholder': '请选择开始时间',
'pages.house.form.rentEndTimePlaceholder': '请选择结束时间',
'pages.house.form.remarksPlaceholder': '请输入备注信息',
'pages.house.form.areaReceipt': '每平方单价',
'pages.house.form.areaReceiptPlaceholder': '请输入每平方单价',
'pages.house.form.bindingInfo': '绑定信息',
'pages.house.form.tab.basic': '基本信息',
'pages.house.form.tab.reserved': '房屋预订',
'pages.house.form.tab.sold': '房屋出售',
'pages.house.form.tab.rented': '房屋出租',
'pages.house.form.tab.finance': '财务登记',
'pages.house.form.tab.repayment': '房屋还款',
'pages.house.form.tab.document': '关联文档',
'pages.house.form.tab.operationLog': '操作日志',
'pages.house.form.reserved.section.info': '预订信息',
'pages.house.form.reserved.reserveUserName': '预定人姓名',
'pages.house.form.reserved.reserveUserNamePlaceholder': '请输入预定人姓名',
'pages.house.form.reserved.reserveUserNameMaxLength': '预定人姓名不超过50个字符',
'pages.house.form.reserved.reserveUserPhone': '预定人手机号',
'pages.house.form.reserved.reserveUserPhonePlaceholder': '请输入预定人手机号',
'pages.house.form.reserved.reserveUserEmail': '预订人邮箱',
'pages.house.form.reserved.reserveUserEmailPlaceholder': '请输入预订人邮箱',
'pages.house.form.reserved.reserveUserEmailPattern': '请输入正确的邮箱格式',
'pages.house.form.reserved.reserveTime': '预定时间',
'pages.house.form.reserved.reserveTimePlaceholder': '请选择预定时间',
'pages.house.form.reserved.section.agentInfo': '中介信息',
'pages.house.form.reserved.agent': '房屋中介',
'pages.house.form.reserved.agentPlaceholder': '请选择房屋中介',
'pages.house.form.reserved.agentCompany': '中介公司',
'pages.house.form.button.cancelReservation': '取消预定',
'pages.house.form.button.cancelSale': '取消出售',
'pages.house.form.button.cancelRent': '取消出租',
'pages.house.form.updateSuccess': '更新成功',
'pages.house.form.createSuccess': '创建成功',
'pages.house.form.updateFailed': '更新失败',
'pages.house.form.createFailed': '创建失败',

// 房屋财务登记弹窗
'pages.house.financeModal.title.create': '新建财务登记',
'pages.house.financeModal.label.houseInfo': '房屋信息',
'pages.house.financeModal.label.amountType': '金额类型',
'pages.house.financeModal.label.amount': '金额',
'pages.house.financeModal.label.bankStatement': '银行账单',
'pages.house.financeModal.label.remarks': '备注',
'pages.house.financeModal.placeholder.amountType': '请选择金额类型',
'pages.house.financeModal.placeholder.feeType': '请选择费用类型',
'pages.house.financeModal.placeholder.amount': '请输入金额',
'pages.house.financeModal.placeholder.bankStatement': '请输入关键词搜索银行账单',
'pages.house.financeModal.placeholder.remarks': '请输入备注信息',
'pages.house.financeModal.validation.amountTypeRequired': '请选择金额类型',
'pages.house.financeModal.validation.feeTypeRequired': '请选择费用类型',
'pages.house.financeModal.validation.amountRequired': '请输入金额',
'pages.house.financeModal.validation.bankStatementRequired': '请选择银行账单',
'pages.house.financeModal.amountType.income': '收入',
'pages.house.financeModal.amountType.expense': '支出',
'pages.house.financeModal.dictLabel.realEstateFeeType': '房产费用类型',
'pages.house.financeModal.message.houseIdMissing': '房屋ID不存在',
'pages.house.financeModal.message.createSuccess': '财务登记成功',
'pages.house.financeModal.message.createFailed': '财务登记失败',
'pages.house.financeModal.message.createFailedRetry': '财务登记失败，请稍后重试',

// 业主选择弹窗
'pages.house.owner.modal.title': '选择业主',
'pages.house.owner.modal.okText': '确认选择',
'pages.house.owner.modal.cancelText': '取消',
  'pages.house.owner.select.placeholder': '请选择一个业主',
  'pages.house.owner.select.required': '请先选择业主',
  'pages.house.owner.bind.button': '绑定业主',
  'pages.house.owner.bind.success': '绑定业主成功',
  'pages.house.owner.bind.failed': '绑定业主失败',
  'pages.house.owner.unbind.button': '解除绑定',
  'pages.house.owner.unbind.confirm.title': '确认解除当前业主绑定？',
  'pages.house.owner.unbind.success': '解除绑定成功',
  'pages.house.owner.unbind.failed': '解除绑定失败',
  'pages.house.owner.edit.button': '编辑业主信息',
  'pages.house.owner.update.success': '业主信息更新成功',
  'pages.house.owner.update.failed': '业主信息更新失败',
'pages.house.owner.table.select': '选择',
'pages.house.owner.table.username': '用户名',
'pages.house.owner.table.name': '姓名',
'pages.house.owner.table.phone': '手机号',
'pages.house.owner.table.email': '邮箱',
'pages.house.owner.table.idCard': '身份证号',
'pages.house.owner.table.status': '状态',
'pages.house.owner.status.enabled': '正常',
'pages.house.owner.status.disabled': '禁用',

// 楼栋楼层树
'pages.house.buildingTree.title': '楼栋楼层选择',
'pages.house.buildingTree.collapse': '收起',
'pages.house.buildingTree.expand': '展开',

// 出租房管理
'pages.house.rental.pageTitle': '出租房管理',
'pages.house.rental.breadcrumb.rental': '租聘管理',
'pages.house.rental.breadcrumb.rentalHouse': '出租房管理',
'pages.house.rental.action.create': '新增',
'pages.house.rental.action.search': '搜索',
'pages.house.rental.action.view': '查看',
'pages.house.rental.action.addSnapshot': '添加照片',
'pages.house.rental.action.addAttachment': '添加附件',
'pages.house.rental.action.download': '下载',
'pages.house.rental.status.notRented': '未出租',
'pages.house.rental.status.rented': '已出租',
'pages.house.rental.status.vacant': '空置',
'pages.house.rental.filter.houseType': '类型：',
'pages.house.rental.filter.houseTypeEmpty': '暂无户型配置',
'pages.house.rental.filter.parking': '车位',
'pages.house.rental.balcony.has': '有阳台',
'pages.house.rental.balcony.none': '无阳台',
'pages.house.rental.balcony.unknown': '未知',
'pages.house.rental.search.aliasPlaceholder': '请输入房屋别名（模糊搜索）',
'pages.house.rental.empty.noData': '暂无数据',
'pages.house.rental.empty.noImage': '暂无图片',
'pages.house.rental.empty.noPhotos': '暂无房屋照片，请添加照片',
'pages.house.rental.empty.noAttachments': '暂无附件资料，请添加附件',
'pages.house.rental.card.monthlyRent': '月租金：{price}',
'pages.house.rental.confirm.delete': '确定要删除这条出租房记录吗？',
'pages.house.rental.pagination.total': '第 {from}-{to} 条/总共 {total} 条',
'pages.house.rental.message.listFailed': '获取出租房列表失败',
'pages.house.rental.message.deleteMissingId': '缺少ID，删除失败',
'pages.house.rental.message.deleteSuccess': '删除成功',
'pages.house.rental.message.deleteFailed': '删除失败',
'pages.house.rental.message.imageOnly': '仅支持上传图片或视频文件',
'pages.house.rental.message.imageLimit': '图片大小不能超过 50MB',
'pages.house.rental.message.videoLimit': '视频大小不能超过 200MB',
'pages.house.rental.message.photoUploadSuccess': '上传成功',
'pages.house.rental.message.fileLimit': '文件大小不能超过 50MB',
'pages.house.rental.message.attachmentUploadSuccess': '附件上传成功',
'pages.house.rental.message.updateSuccess': '更新成功',
'pages.house.rental.message.updateFailed': '更新失败',
'pages.house.rental.message.noChanges': '没有需要保存的更改',
'pages.house.rental.message.createSuccess': '新增成功',
'pages.house.rental.message.createFailed': '新增失败',
'pages.house.rental.form.title.edit': '编辑出租房',
'pages.house.rental.form.title.create': '新增出租房',
'pages.house.rental.tab.basic': '基本信息',
'pages.house.rental.tab.photos': '房屋照片',
'pages.house.rental.tab.files': '出租文件',
'pages.house.rental.tab.houseDocuments': '房屋文件',
'pages.house.rental.tab.extra': '补充信息',
'pages.house.rental.section.basic': '基本信息',
'pages.house.rental.section.rental': '租赁信息',
  'pages.house.rental.section.ownerInfo': '房主信息',
'pages.house.rental.section.agent': '中介信息',
'pages.house.rental.section.extra': '补充信息',
'pages.house.rental.form.alias': '房屋别名',
'pages.house.rental.form.layout': '户型',
'pages.house.rental.form.area': '房屋面积(㎡)',
'pages.house.rental.form.hasBalcony': '是否有阳台',
'pages.house.rental.form.status': '出租状态',
'pages.house.rental.form.location': '房屋位置',
'pages.house.rental.form.locationCity': '城市',
'pages.house.rental.form.locationCommunity': '小区',
'pages.house.rental.form.locationBuilding': '楼栋',
  'pages.house.rental.form.houseUser': '房主名称',
  'pages.house.rental.form.houseUserMobile': '房主电话',
'pages.house.rental.form.rentalPrice': '月租金',
'pages.house.rental.form.estimatedPrice': '买入价格',
'pages.house.rental.form.agentName': '中介名称',
'pages.house.rental.form.agentFee': '中介费用',
'pages.house.rental.form.remarks': '备注',
'pages.house.rental.form.homeList': '家电清单',
'pages.house.rental.form.description': '其他补充描述',
'pages.house.rental.form.name': '名称',
'pages.house.rental.form.snapshotUpload': '照片/视频 (图片 JPG/PNG ≤50MB，视频 MP4/MOV ≤200MB)',
'pages.house.rental.form.attachmentUpload': '附件文件 (支持常见格式，≤50MB)',
'pages.house.rental.placeholder.alias': '请输入房屋别名',
'pages.house.rental.placeholder.layout': '请选择户型',
'pages.house.rental.placeholder.area': '请输入面积',
'pages.house.rental.placeholder.select': '请选择',
'pages.house.rental.placeholder.status': '请选择出租状态',
'pages.house.rental.placeholder.location': '请输入房屋位置',
'pages.house.rental.placeholder.locationCity': '请输入城市',
'pages.house.rental.placeholder.locationCommunity': '请输入小区',
'pages.house.rental.placeholder.locationBuilding': '请输入楼栋',
  'pages.house.rental.placeholder.houseUser': '请输入房主名称',
  'pages.house.rental.placeholder.houseUserMobile': '请输入房主电话',
'pages.house.rental.placeholder.rentalPrice': '请输入月租金',
'pages.house.rental.placeholder.estimatedPrice': '请输入买入价格',
'pages.house.rental.placeholder.agentName': '请输入中介名称',
'pages.house.rental.placeholder.agentFee': '请输入中介费用',
'pages.house.rental.placeholder.remarks': '请输入备注',
'pages.house.rental.placeholder.homeList': '请输入家电清单',
'pages.house.rental.placeholder.description': '请输入补充说明',
'pages.house.rental.placeholder.photoName': '请输入照片名称',
'pages.house.rental.placeholder.attachmentName': '请输入附件名称',
'pages.house.rental.validation.aliasRequired': '请输入房屋别名',
'pages.house.rental.validation.hasBalconyRequired': '请选择是否有阳台',
'pages.house.rental.validation.statusRequired': '请选择出租状态',
'pages.house.rental.validation.locationRequired': '请输入房屋位置',
'pages.house.rental.validation.locationCityRequired': '请输入城市',
'pages.house.rental.validation.locationCommunityRequired': '请输入小区',
'pages.house.rental.validation.locationBuildingRequired': '请输入楼栋',
'pages.house.rental.validation.nameRequired': '请输入名称',
'pages.house.rental.validation.attachmentNameRequired': '请输入附件名称',
'pages.house.rental.validation.uploadPhotoFirst': '请先上传照片或视频',
'pages.house.rental.validation.uploadAttachmentFirst': '请先上传附件',
'pages.house.rental.option.yes': '有',
'pages.house.rental.option.no': '无',
'pages.house.rental.option.unknown': '未知',
'pages.house.rental.photo.title': '房屋照片',
'pages.house.rental.photo.tip': '第一张图片用于出租房屋的图片展示。',
'pages.house.rental.photo.defaultName': '房屋照片',
'pages.house.rental.file.title': '出租文件',
'pages.house.rental.file.defaultName': '出租文件',
'pages.house.rental.houseDocument.title': '房屋文件',
'pages.house.rental.houseDocument.defaultName': '房屋文件',
'pages.house.rental.empty.noHouseDocuments': '暂无房屋文件，请添加文件',
'pages.house.rental.modal.houseDocumentCreateTitle': '添加房屋文件',
'pages.house.rental.modal.photoCreateTitle': '新增房屋照片',
'pages.house.rental.modal.attachmentCreateTitle': '新增附件资料',
'pages.house.rental.modal.previewPhotoTitle': '查看照片',
'pages.house.rental.upload.photo.text': '点击或拖拽上传房屋照片或视频',
'pages.house.rental.upload.photo.hint': '图片支持 JPG、PNG，不超过 50MB；视频支持 MP4、MOV，不超过 200MB',
'pages.house.rental.upload.attachment.text': '点击或拖拽上传附件文件',
'pages.house.rental.upload.attachment.hint':
  '支持 PDF、Word、Excel、图片等常见格式，文件大小不超过 50MB',
'pages.house.rental.upload.loading': '上传中...',
'pages.house.rental.appliance.tv': '电视',
'pages.house.rental.appliance.fridge': '冰箱',
'pages.house.rental.appliance.microwave': '微波炉',
'pages.house.rental.appliance.riceCooker': '电饭锅',
'pages.house.rental.appliance.kettle': '热水壶',
'pages.house.rental.appliance.washer': '洗衣机',
'pages.house.rental.appliance.bed': '床',
'pages.house.rental.appliance.table': '桌子',
'pages.house.rental.appliance.ac': '空调',
'pages.house.rental.appliance.waterHeater': '热水器',
'pages.house.rental.appliance.sofa': '沙发',
'pages.house.rental.appliance.wardrobe': '衣柜',

// 通用操作键
'common.action.create': '新建',
'common.action.add': '添加',
'common.action.edit': '编辑',
'common.action.delete': '删除',
'common.action.confirm': '确定',
'common.action.cancel': '取消',
'common.action.save': '保存',
'common.action.clear': '清空',
'common.action.deselect': '取消选择',
'common.action.batchDelete': '批量删除',
'common.label.selected': '已选择',
'common.label.items': '项',
'common.confirm.delete': '确定要删除这条记录吗？',
'common.confirm.batchDelete': '确定要批量删除选中的记录吗？',
};
